module.exports = __webpack_public_path__ + "img/shoot_00003.1eea875f.png";